//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import redBorderDialog from "./redBorderDialog.vue";
import collectionDialog from "./collectionDialog.vue";
export default {
  props: {
    applicationNoUuid: {
      type: String,
      default: "",
    },
  },
  components: {
    redBorderDialog,
    collectionDialog
  },
  data() {
    return {
      redBorderDialogBool: false,
      collectionDialog: false,
      list: [],
    };
  },
  methods: {
    openRedBorderDialog(type, item) {
      this.redBorderDialogBool = true;
      this.$nextTick(() => {
        this.$refs.RedBorderDialog.init(type, item);
      });
    },
    openCollectionDialog(item) {
      this.collectionDialog = true;
      this.$nextTick(() => {
        this.$refs.collectionDialog.init(item);
      });
    },
    async findOfferProcess() {
      let params = {
        applicationNoUuid: this.applicationNoUuid,
      };
      let url = "api/api/findOfferProcess";
      this.axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          this.list = data.data.record;
        }
      });
    },
    async clickTodo(item) {
      if (item.currentFlow == 'Payslips Upload') {
        this.openRedBorderDialog('payslipsUpload', item);
      } else if (item.currentFlow == 'Offer Acceptance') {
        this.openRedBorderDialog('offerAcceptance', item)
      } else {
        this.openCollectionDialog(item);
      }
    }
  },
  created() {
    this.findOfferProcess();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/ToDo.vue